import script from "./buy-now-trial.vue?vue&type=script&lang=js"
export * from "./buy-now-trial.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__